import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import BookingModal from "./BookingModal";

function Services() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedService, setSelectedService] = useState(null);

  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + "/primedale_services")
      .then(res => res.json())
      .then(data => {
        const normalized = data.map(service => ({
          ...service,
          features:
            typeof service.features === "string"
              ? JSON.parse(service.features)
              : service.features
        }));
        setServices(normalized);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <>
      <Helmet>
        <title>Corporate Travel Services | PrimeDale</title>
      </Helmet>

      <div>
        {/* Hero */}
        <div className="container-fluid bg-primary py-5 mb-5 hero-header">
          <div className="container py-5 text-center">
            <h1 className="display-3 text-white">
              Our Services
            </h1>
          </div>
        </div>

        {/* Services */}
        <div className="container-xxl py-5">
          <div className="container">

            <div className="row g-4">
              {loading && <p>Loading...</p>}

              {services.map((service, index) => (
                <div
                  className="col-lg-6 wow fadeInUp"
                  key={service.id}
                >
                  <div className="service-item rounded pt-3 h-100">
                    <div className="p-4">
                      <i className={`icon-color fa fa-3x ${service.icon} mb-4`} />
                      <h5 className="footer-color">{service.title}</h5>
                      <p>{service.description}</p>

                      <ul>
                        {service.features?.map((f, i) => (
                          <li key={i}>{f}</li>
                        ))}
                      </ul>

                      {/* 🔥 BOOK BUTTON */}
                      <button
                        className="btn  mt-3"
                        onClick={() => setSelectedService(service.title)}
                      >
                        Book Now
                      </button>

                    </div>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>

        {/* Modal */}
        <BookingModal
          show={!!selectedService}
          service={selectedService}
          onClose={() => setSelectedService(null)}
        />
      </div>
    </>
  );
}

export default Services;